<!--
 * @Author: Tahiti
 * @Date: 2025-11-04
 * @LastEditors: Tahiti
 * @LastEditTime: 2026-01-04 17:36:23
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/ProjectTab.vue
-->
<template>
    <div
        class="relative left-0 bg-[#000000] flex w-full flex-none border-b border-b-third-default h-[64px] right-0 z-[49] lg:hidden">
        <!-- 移动端：工具选择器居中显示 -->
        <div class="lg:hidden flex items-center w-full h-full relative">
            <!-- 返回按钮 -->
            <button type="button"
                class="absolute left-4 flex items-center justify-center w-8 h-8 rounded-full hover:bg-white/10 transition-all duration-200 active:scale-95"
                @click="handleBackToHome">
                <svg class="w-5 h-5 text-white" viewBox="0 0 24 24" fill="none">
                    <path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </button>

            <!-- 工具选择器居中 -->
            <div class="flex-1 flex items-center justify-center">
                <MobileToolSelector />
            </div>
        </div>

        <!-- PC端：汉堡菜单（仅在 lg 到 xl 之间显示） -->
        <div class="hidden  items-center w-[50px] h-full justify-center">
            <button type="button" class="hover:scale-110 transition-all duration-200"
                @click="handleToggleSidebarCollapse">
                <img v-if="!appStore.toolSidebarOpen" src="/assets/images/common/menu.svg" alt="menu" class="w-6 h-6" />
                <img v-else src="/assets/images/common/_close.webp" alt="menu" class="w-6 h-6" />
            </button>
        </div>
        <!-- PC端：项目标签 -->
        <div ref="tabContainerRef" class="hidden lg:flex h-full items-center justify-between overflow-x-auto pr-[50px]">
            <div class="flex items-center justify-start h-full">
                <div v-for="tab in filteredProjectList" :key="tab?.id"
                    class="group flex tab-item max-w-[240px] truncate border-r border-r-transparent flex-shrink-0 h-full items-center justify-start hover:bg-[#26262A] hover:text-white px-[10px] cursor-pointer transition-all duration-300"
                    :class="appStore.currentProject?.id === tab?.id
                        ? 'bg-[#26262A] text-white'
                        : 'text-default-tab !border-r-third-default'
                        " @click="handleTabClick(tab)">
                    <span class="w-full truncate flex items-center justify-between gap-4">
                        <span class="flex items-center">
                            <span class="i-tab-icon w-[18px] h-[18px] mr-1">
                            </span>
                            <span class="text-sm max-w-[140px] truncate font-medium whitespace-nowrap">
                                {{ tab?.name }}
                            </span>
                        </span>
                        <span class="action-icons flex items-center gap-[10px]" :class="activeTabId === tab?.id
                            ? 'visible'
                            : 'invisible group-hover:visible'
                            ">
                            <!-- edit -->
                            <span @click="handleEditClick(tab)"
                                class="i-tab-edit-icon w-4 h-4 text-default-tab hover:text-text-active cursor-pointer transition-all duration-300 hover:scale-110">
                            </span>
                            <!-- delete -->
                            <span v-if="filteredProjectList.length > 1"
                                class="i-tab-delete-icon w-4 h-4 text-default-tab hover:text-text-active cursor-pointer transition-all duration-300 hover:scale-110"
                                @click="handleDeleteClick(tab)">
                            </span>
                        </span>
                    </span>
                </div>
                <!-- action -->
                <div v-if="filteredProjectList?.length" class="flex items-center justify-center flex-shrink-0">
                    <span @click="handleAddClick()"
                        class="i-tab-add-icon ml-2 text-default-tab hover:text-text-active cursor-pointer transition-all duration-300 hover:scale-110 w-[14px] h-[14px]">
                    </span>
                </div>
            </div>

            <el-popover v-if="hasScrollbar" :width="300" trigger="hover">
                <template #reference>
                    <div
                        class="flex absolute right-0 bg-[#000000] items-center justify-center h-full w-[44px] border-l border-third-default">
                        <img class="w-6 h-6"
                            src="https://static.weryai.com/growth/image/dee11391130a79118202dcc50cbf6e37.webp"
                            alt="more" />
                    </div>
                </template>
                <div class="max-h-[400px] overflow-y-auto">
                    <div
                        class="flex items-center justify-center mb-2 flex-shrink-0 border-b border-b-third-default pb-2">
                        <span @click="handleAddClick()"
                            class="i-tab-add-icon ml-2 text-white hover:text-text-active cursor-pointer transition-all duration-300 hover:scale-110 w-[14px] h-[14px]">
                        </span>
                    </div>
                    <div v-for="tab in filteredProjectList" :key="tab?.id"
                        class="px-2 h-[44px] flex items-center text-white justify-start py-1 mb-2 rounded-lg hover:bg-[#26262A] hover:text-text-active cursor-pointer transition-all duration-300"
                        :class="appStore.currentProject?.id === tab?.id
                            ? 'bg-[#26262A] text-text-active'
                            : 'text-default-tab'
                            " @click="handleTabClick(tab)">
                        <div class="flex items-center truncate justify-start">
                            <span class="i-tab-icon flex-shrink-0 w-[18px] h-[18px] mr-1">
                            </span>
                            <span class="text-sm truncate font-medium">
                                {{ tab?.name }}
                            </span>
                        </div>
                    </div>
                </div>
            </el-popover>
        </div>
    </div>

    <transition v-if="dialogVisible" name="fade">
        <div class="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black/50 backdrop-blur-sm z-[50]"
            @click.self="dialogVisible = false">
            <div
                class="flex flex-col relative p-4 w-[500px] h-[300px] bg-setting-bg rounded-lg items-center justify-center">
                <div class="flex w-full p-4 items-center justify-between absolute top-0 left-0 right-0">
                    <h2 class="text-white text-lg font-medium">
                        {{
                            edit_item?.id
                                ? t('batchTools.editProject')
                                : t('batchTools.addProject')
                        }}
                    </h2>
                    <span
                        class="text-2xl cursor-pointer hover:text-text-active transition-all duration-300 hover:scale-110"
                        @click="dialogVisible = false">
                        ×
                    </span>
                </div>
                <div class="w-full">
                    <el-input class="h-[44px]" v-model="edit_item.name"
                        :placeholder="t('batchTools.placeholderName')" />
                </div>

                <div class="w-full absolute bottom-5 p-5 flex items-center justify-center gap-2">
                    <el-button @click="dialogVisible = false"
                        class="hover:!border-white/30 hover:!bg-transparent hover:!text-white">{{ t('batchTools.cancel')
                        }}</el-button>
                    <el-button :loading="loading" type="primary" @click="handleSubmitProject()"
                        class="!text-black hover:!bg-[var(--active-btn)] hover:!border-transparent">{{
                            t('batchTools.confirm') }}</el-button>
                </div>
            </div>
        </div>
    </transition>
    <!-- add/edit modal -->

    <!-- delete modal -->
    <el-dialog v-model="deleteDialogVisible" :title="t('batchTools.deleteConfirmTitle')" width="30%">
        <p>{{ t('batchTools.deleteConfirmMessage') }}</p>
        <template #footer>
            <el-button class="hover:!border-white/30 hover:!bg-transparent hover:!text-white"
                @click="deleteDialogVisible = false">{{ t('batchTools.cancel') }}</el-button>
            <el-button class="hover:!bg-[var(--active-btn)] !text-black hover:!border-transparent"
                :loading="deleteLoading" type="primary" @click="handleConfirmDelete()">{{ t('batchTools.confirm')
                }}</el-button>
        </template>
    </el-dialog>
</template>

<script setup lang="ts">
import { ref, computed, nextTick, watch, onMounted, onUnmounted } from 'vue'
import { navigateTo } from '#imports'
import { useAppStore } from '@/stores/app'
import { useUserStore } from '@/stores/user'
import { useI18n } from '~/composables/useI18n'
import { noticeMessagePopup } from '~/utils/common'
import { emitRefreshCreationHistory } from '~/utils/emitter'

const { t } = useI18n()
const appStore = useAppStore()
const userStore = useUserStore()

// 未登录（且没有任何 token）时隐藏顶部栏，避免刷新恢复登录态时的闪动
const shouldShowProjectTab = computed(
    () => userStore.isLoggedIn || userStore.hasToken
)

// 移动端返回按钮 - 返回 /chat 的创作 Tab
// 优先尝试 SPA 导航（体验流畅、无白屏）
// 如果跨 layout 切换失败（URL 变了但页面没切换），自动降级为全量导航
const handleBackToHome = async () => {
    const targetPath = '/chat?tab=creation'

    try {
        await navigateTo(targetPath)

        // 给 Nuxt 200ms 完成 layout 切换
        await new Promise(resolve => setTimeout(resolve, 200))

        // 检测 chat layout 的底部导航是否已挂载
        const footerMenu = document.querySelector('.menu-bar')
        if (!footerMenu) {
            // layout 切换失败，降级为全量导航
            window.location.href = targetPath
        }
    } catch {
        // navigateTo 异常，降级为全量导航
        window.location.href = targetPath
    }
}

// 获取 ToolSidebar 宽度
const toolSidebarWidth = computed(() => appStore.toolSidebarWidth || 100)

const dialogVisible = ref(false)

// Tab容器引用
const tabContainerRef = ref<HTMLElement | null>(null)
// 是否有滚动条
const hasScrollbar = ref(false)

/**
 * 检查是否有滚动条
 */
const checkScrollbar = () => {
    nextTick(() => {
        if (tabContainerRef.value) {
            // 比较滚动宽度和可见宽度，如果滚动宽度大于可见宽度，说明有滚动条
            hasScrollbar.value =
                tabContainerRef.value.scrollWidth >
                tabContainerRef.value.clientWidth
        }
    })
}

// 删除确认弹窗相关状态
const deleteDialogVisible = ref(false)
const deleteLoading = ref(false)
const tabToDelete = ref<any>(null)

const initProjectItem = () => {
    return {
        id: null,
        name: '',
    }
}
const project_item = ref(initProjectItem())
const edit_item = ref<any>(null)

const loading = ref(false)
const handleAddClick = () => {
    dialogVisible.value = true
    edit_item.value = initProjectItem()
}
const handleSubmitProject = async () => {
    if (!edit_item.value.name.trim()) {
        noticeMessagePopup(
            t('batchTools.placeholderName'),
            t('common.tip'),
            'warning',
            5000,
            ''
        )
        return
    }
    loading.value = true

    try {
        const is_edit = edit_item.value?.id && edit_item.value?.id !== -1
        const res: boolean = is_edit
            ? await appStore.updateProject(
                edit_item.value?.id || '',
                edit_item.value
            )
            : await appStore.createProject({
                name: edit_item.value.name,
            })
        if (res) {
            dialogVisible.value = false
            edit_item.value = initProjectItem()
            // 添加/编辑项目后检查滚动条
            checkScrollbar()
        }
    } catch (e) {
    } finally {
        loading.value = false
    }
}

/**
 * 过滤后的项目列表
 * 1. 过滤掉 null 或 undefined 值
 * 2. 过滤掉重复 ID 的项（保留第一个出现的）
 * 3. 如果项目列表大于两项时，删除 id 为 -1 的一项
 */
const filteredProjectList = computed(() => {
    if (!appStore.projectList || !Array.isArray(appStore.projectList)) {
        return []
    }

    // 先过滤掉 null 或 undefined 值
    let filtered = appStore.projectList.filter(
        (tab: any) => tab != null && tab.id != null
    )

    // 去重：保留第一个出现的，删除后续重复 ID 的项
    const seenIds = new Set()
    filtered = filtered.filter((tab: any) => {
        if (seenIds.has(tab.id)) {
            return false // 如果已经见过这个 ID，过滤掉
        }
        seenIds.add(tab.id)
        return true
    })

    // 如果项目列表大于一项时，删除 id 为 -1 的一项
    if (filtered.length > 1) {
        filtered = filtered.filter((tab: any) => tab.id !== -1)
    }

    return filtered
})

/**
 * 当前激活的Tab ID
 */
const activeTabId = ref<string>('')
let initTabsPromise: Promise<void> | null = null

/**
 * 初始化Tab列表
 */
const initTabs = async () => {
    // 项目列表只服务登录后的交互，SSR/匿名首屏无需等待用户态接口。
    if (!import.meta.client || !shouldShowProjectTab.value) return
    if (initTabsPromise) return initTabsPromise

    initTabsPromise = (async () => {
        await appStore.getProjectList()

        activeTabId.value = appStore.currentProject?.id || ''
        // 初始化后检查滚动条
        checkScrollbar()
    })()

    try {
        await initTabsPromise
    } finally {
        initTabsPromise = null
    }
}

/**
 * 处理Tab点击
 */
const handleTabClick = (item: any) => {
    // 如果 item 为空或没有 id，直接返回
    if (!item || !item.id) {
        return
    }

    appStore.changeCurrentProject(item)
    // 保存完成后，切换到新的Tab
    activeTabId.value = item.id
}

/**
 * 处理编辑按钮点击
 */
const handleEditClick = (tab: any) => {
    if (!activeTabId.value || !tab || !tab.id) return
    const { id, name } = tab
    edit_item.value = {
        id,
        name,
    }
    dialogVisible.value = true
}

/**
 * 处理删除按钮点击
 */
const handleDeleteClick = (tab: any) => {
    if (
        !tab ||
        !tab.id ||
        !activeTabId.value
        // ||
        // filteredProjectList.value.length <= 1
    ) {
        // 至少保留一个Tab
        return
    }
    // 保存要删除的tab，显示确认弹窗
    tabToDelete.value = tab
    deleteDialogVisible.value = true
}

/**
 * 确认删除
 */
const handleConfirmDelete = async () => {
    if (!tabToDelete.value || !tabToDelete.value.id) {
        deleteDialogVisible.value = false
        return
    }

    const deletedTabId = tabToDelete.value.id
    const wasCurrentTab = activeTabId.value === deletedTabId

    deleteLoading.value = true
    try {
        const res = await appStore.deleteProject(deletedTabId)
        if (res) {
            // 等待列表更新完成（deleteProject内部已调用getProjectList）
            await nextTick()

            // 如果删除的是当前激活的tab，切换到第一个tab
            if (wasCurrentTab) {
                // 等待列表更新完成
                await nextTick()
                const remainingTabs = appStore.projectList?.filter(
                    (t: any) => t?.id !== deletedTabId
                )

                if (remainingTabs && remainingTabs.length > 0) {
                    const firstTab = remainingTabs[0]

                    appStore.changeCurrentProject(firstTab)
                    activeTabId.value = firstTab.id
                }
            }
            // 关闭弹窗并清空待删除的tab
            deleteDialogVisible.value = false
            tabToDelete.value = null
            // 删除项目后检查滚动条
            checkScrollbar()
        }
    } catch (e) {
        console.error('删除项目失败:', e)
    } finally {
        deleteLoading.value = false
    }
}

// 菜单按钮点击
const handleToggleSidebarCollapse = () => {
    appStore.setToolSidebarOpen(!appStore.toolSidebarOpen)
}

watch(
    () => appStore.currentProject,
    newVal => {
        if (newVal && newVal?.id) {
            emitRefreshCreationHistory()
            project_item.value = {
                id: newVal.id,
                name: newVal.name,
            }
            activeTabId.value = newVal.id
        }
    },
    {
        immediate: true,
        deep: true,
    }
)

watch(
    () => dialogVisible.value,
    newVal => {
        if (!newVal) {
            edit_item.value = initProjectItem()
        }
    }
)

watch(
    () => deleteDialogVisible.value,
    newVal => {
        if (!newVal) {
            edit_item.value = initProjectItem()
        }
    }
)

// 监听项目列表变化，检查滚动条
watch(
    () => filteredProjectList.value,
    () => {
        checkScrollbar()
    },
    { deep: true }
)

// 监听窗口大小变化，检查滚动条
let resizeObserver: ResizeObserver | null = null

onMounted(() => {
    void initTabs()

    // 等待 DOM 渲染完成后再检查滚动条和设置监听
    nextTick(() => {
        // 检查滚动条
        checkScrollbar()

        // 使用 ResizeObserver 监听容器大小变化
        if (tabContainerRef.value) {
            resizeObserver = new ResizeObserver(() => {
                checkScrollbar()
            })
            resizeObserver.observe(tabContainerRef.value)
        }
    })

    // 监听窗口大小变化
    window.addEventListener('resize', checkScrollbar)
})

watch(shouldShowProjectTab, visible => {
    if (visible) void initTabs()
})

onUnmounted(() => {
    // 清理 ResizeObserver
    if (resizeObserver && tabContainerRef.value) {
        resizeObserver.unobserve(tabContainerRef.value)
        resizeObserver.disconnect()
    }
    // 移除窗口大小变化监听
    window.removeEventListener('resize', checkScrollbar)
})
</script>

<style scoped lang="less">
.tab-item {
    transition: all 0.3s ease;
}

:deep(::-webkit-scrollbar) {
    height: 4px;
}

:deep(::-webkit-scrollbar-track) {
    background: transparent;
}

:deep(::-webkit-scrollbar-thumb) {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 2px;
}

:deep(::-webkit-scrollbar-thumb:hover) {
    background: rgba(255, 255, 255, 0.3);
}

input {
    &::placeholder {
        color: #999;
    }
}

:deep(.el-input__wrapper) {
    border-radius: 8px;
}

:deep(.el-input__wrapper.is-focus) {
    border-color: rgba(255, 255, 255, 0.3);
}
</style>
